import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {SurveyEnum} from "../views/SurveyService/SurveyEnum";

export const surveySlice = createSlice<{
  selected?: { id: string, type: SurveyEnum }
}, {
  set: (state: any, action: PayloadAction<{type: SurveyEnum, id: string}>) => void,
  clear: (state: any) => void
},"surveys">({
  name: "surveys",
  initialState: {
    selected: undefined,
  },
  reducers: {
    set: (state, action: PayloadAction<{type:SurveyEnum, id:string}>) => {
      state.selected = action.payload
    },
    clear: (state) => {
      state.selected = undefined
    },
  }
})

export const { set: selectSurvey, clear: unselectSurvey } = surveySlice.actions;
export default surveySlice.reducer;
